import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';

import axios from 'axios';
import { useSelector } from 'react-redux';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import IndexH from '../../pages/subcatpages/IndexH';
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';

//
import VerticalAd from '../../components/ads/VerticalAd';


// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const [userData, setUserData] = useState({});

  const BlankPofile = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png';
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
       // Data after sending the token Validation__Authorization
       const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${userInfo?.access}`,
        },
      };
      //  getting sub_User_Data Function
      const getUserData = async () => {
        if (userInfo) {
          const response = await axios.get(
            `${process.env.REACT_APP_API_KEY}/api/v1/accounts/user-details/${userInfo.id}`,
            config
          );
          setUserData(response.data);
        } else {
          console.log("you arnot loged");
        }
      };
      useEffect(() => {
        getUserData();
      },[]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >

      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to={userInfo ? '/dashboard/profile' : '/login'}>
          <AccountStyle>
            <Avatar
              src={userInfo ? `${process.env.REACT_APP_API_KEY}${userData?.avatarUrl}` : BlankPofile}
              alt="photoURL"
            />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {userInfo ? <>{userInfo.name}</> : 'Unknown User'}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
    
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
         {/* <CreatorGroupBtn userData={userData} /> */}
        </Drawer>
      )}
    </RootStyle>
  );
}
